'use client';

import { type HTMLAttributes } from 'react';

import dynamic from 'next/dynamic';

import { cn } from '@/libs';

import { useLottieData } from './hooks';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

type LottieAnimationProps = HTMLAttributes<HTMLDivElement> & {
  src: string;
  loop?: boolean;
};

export const LottieAnimation = ({
  src = '/animations/confetti.json',
  loop = true,
  className,
  ...props
}: LottieAnimationProps) => {
  const animationData = useLottieData(src);
  if (!animationData) return null;

  return (
    <div {...props} className={cn('relative w-full h-full', className)}>
      <Lottie
        loop={loop}
        animationData={animationData}
        className="absolute w-full h-full inset-0"
      />
    </div>
  );
};
